// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Intervenants_userCards__U98v9 {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 10px;
    align-items: flex-start;
    
}
.Intervenants_paginationContainer__Z\\+0pE {
    display: flex;
    justify-content: center;
  }
`, "",{"version":3,"sources":["webpack://./src/Pages/IntervenantsPage/Intervenants/Intervenants.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,SAAS;IACT,uBAAuB;;AAE3B;AACA;IACI,aAAa;IACb,uBAAuB;EACzB","sourcesContent":[".userCards {\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    gap: 10px;\n    align-items: flex-start;\n    \n}\n.paginationContainer {\n    display: flex;\n    justify-content: center;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userCards": `Intervenants_userCards__U98v9`,
	"paginationContainer": `Intervenants_paginationContainer__Z+0pE`
};
export default ___CSS_LOADER_EXPORT___;
